import { getColorByString } from "@msuite/utils/colors";
import { getWarehouseZoneTypeTranslationKey } from "@msuite/utils/stock";
import type { Enums } from "@msuite/utils/types";
import { useTranslation } from "../localization";
import { Tag, type TagProps } from "./tag";

/** Props Interface */
interface WarehouseZoneTagProps extends Pick<TagProps, "size"> {
	type: Enums<"warehouseZoneType">;
}

export function WarehouseZoneTag({ type, size }: WarehouseZoneTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			variant="plain"
			color={getColorByString(type)}
			size={size}
		>
			{t(getWarehouseZoneTypeTranslationKey(type))}
		</Tag>
	);
}
